export default function Marquee({ items, dark = true, fast = false }) {
  const text = items.map((i) => `${i}        ·        `).join("");
  return (
    <div
      data-testid="marquee-strip"
      className={`overflow-hidden border-y py-5 md:py-6 ${
        dark ? "border-black bg-black text-white" : "border-black/10 bg-white text-black"
      }`}
    >
      <div className={`flex w-max whitespace-nowrap ${fast ? "animate-aw-marquee-fast" : "animate-aw-marquee"}`}>
        {[0, 1].map((n) => (
          <span key={n} className="font-display text-xl font-bold uppercase tracking-normal md:text-3xl">
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
